{
  "de": {
    "dashboard": {
      "greetings": {
        "afternoon": "Guten Tag {first_name}",
        "evening": "Guten Abend {first_name}",
        "morning": "Guten Morgen {first_name}",
        "night": "Gute Nacht {first_name}"
      },
      "milestones": {
        "action_title_decision": "Wählen Sie {name}",
        "action_title_survey": "Füllen Sie {name} aus",
        "action_title_ticket": "Neue Nachricht zu {name}",
        "count_open": "{count} offen",
        "journey_hide": "Projektverlauf ausblenden",
        "journey_show": "Projektverlauf ansehen",
        "journey_step_active": "In Bearbeitung",
        "journey_step_completed": "Abgeschlossen",
        "journey_step_planned": "Geplant",
        "other_empty_subtitle": "{client} meldet sich bei Ihnen, sobald etwas für Sie bereitsteht.",
        "other_empty_title": "Sie sind auf dem neuesten Stand",
        "other_promoted_title": "Braucht Ihre Aufmerksamkeit",
        "other_title": "Weitere Aktionen",
        "stage_done_subtitle": "{client} meldet sich bei Ihnen, sobald der nächste Schritt ansteht.",
        "stage_done_title": "Alles erledigt für diese Phase",
        "stage_empty": "In dieser Phase gibt es derzeit nichts zu tun.",
        "stage_eyebrow": "Aktuelle Phase",
        "stage_final_subtitle": "Alle Schritte Ihres Projekts sind abgeschlossen. Wir halten Sie auf dem Laufenden, falls sich noch etwas ändert.",
        "stage_final_title": "Sie sind komplett fertig",
        "stage_last": "Dies ist die letzte Phase",
        "stage_next": "Als Nächstes: {phase}",
        "stage_position": "Phase {current} von {total}",
        "stage_todo_title": "Um diese Phase abzuschließen"
      },
      "titles": {
        "activityFeed": "Aktivitäten",
        "assignedTasks": "Meine Aufgaben",
        "newsFeed": "Neuigkeiten",
        "ongoingTickets": "Laufend",
        "openTickets": "Offen",
        "progress": "Fortschritt",
        "tickets": "Konversationen",
        "totalTickets": "Alle Konversationen",
        "unreadTickets": "Ungelesen",
        "yourAssignedTickets": "Ihnen zugewiesen"
      }
    }
  }
}
